import React, { useState } from "react";

type CopyButtonProps = {
  textToCopy: string;
};

const CopyButton = ({ textToCopy }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy); // Copies text to clipboard
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset the copied status after 2 seconds
    } catch (error) {
      console.error("Failed to copy text: ", error);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className="flex items-center space-x-2 bg-navy text-cream p-1 rounded-md hover:bg-navy-light focus:outline-none"
    >
      {/* Rectangle Copy Icon */}
      {!copied ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          className="w-5 h-5"
          strokeWidth="2"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <path d="M8 13h8M8 9h8" />
        </svg>
      ) : (
        "Copied!"
      )}
    </button>
  );
};

export default CopyButton;
